// src/config.js
const BASE_URL =
(process.env.REACT_APP_API_BASE || '').replace(/\/+$/, '') ||
  'http://localhost:5001'; // fallback for local dev if env missing

  if (process.env.NODE_ENV === 'development') {
    console.log('[config] API base:', BASE_URL);
  }
  
export const api = {
  base: BASE_URL,
  url: (path = '') => `${BASE_URL}${path.startsWith('/') ? '' : '/'}${path}`,
};
// 👇 NEW: CloudFront base and a media URL helper
const CDN_BASE = (process.env.REACT_APP_CDN_BASE || '').replace(/\/+$/, '');

/**
 * mediaUrl('/uploads/...') -> CloudFront if REACT_APP_CDN_BASE is set,
 * otherwise falls back to the API origin.
 * If you pass a full http(s) URL, it's returned unchanged.
 */
export const mediaUrl = (path = '') => {
  if (!path) return '';
  if (/^https?:\/\//i.test(path)) return path; // already absolute
  const clean = path.startsWith('/') ? path : `/${path}`;
  if (clean.startsWith('/uploads') && CDN_BASE) {
    return `${CDN_BASE}${clean}`;
  }
  return api.url(clean);
};
